import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FaQuestion, FaQuestionCircle } from 'react-icons/fa';

import { uiActions } from '../../actions';
import TooltipWrapper from '../../components/general/TooltipWrapper';
import useDispatch from '../../hooks/useDispatch';
import useSelector from '../../hooks/useSelector';

const ToggleHelpButtonFloatingButton: React.FC = () => {
  const { showQuestionMarks } = useSelector(state => state.ui.floatTutorial);

  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    if (showQuestionMarks) {
      dispatch(uiActions.floatTutorial.hideQuestionMarks());
    } else {
      dispatch(uiActions.floatTutorial.showQuestionMarks());
    }
  }, [dispatch, showQuestionMarks]);

  const [t] = useTranslation();

  return (
    <div>
      <TooltipWrapper
        tooltip={t(
          showQuestionMarks ? 'hide-question-buttons' : 'show-question-buttons'
        )}
      >
        <div
          id="toggle-question-float-button"
          className={classNames('float-button', {
            active: showQuestionMarks,
          })}
          onClick={handleClick}
        >
          {showQuestionMarks ? <FaQuestionCircle /> : <FaQuestion />}
        </div>
      </TooltipWrapper>
    </div>
  );
};

export default ToggleHelpButtonFloatingButton;
